import React, {
    useContext,
    useState,
    Fragment,
    useMemo,
    useEffect,
} from "react";
import { WaitingListFlowContext } from "../WaitingListFlowContext";
import { WaitingListPreview } from "../partials/WaitingListPreview";
import { useProductAvailability } from "../hooks/useProductAvailability";
import { RadioButtonListWithLabel } from "../../../../../Resources/Scripts/_Shared/elements/RadioButtonListWithLabel";
import { shouldAccountBeUpdated } from "../../../../../Resources/Scripts/_Shared/helpers";
import { BackNavigation } from "../partials/BackNavigation";

import _ from "lodash";

const WaitingListProductDisplay = () => {
    const { waitingListFlowContext, setWaitingListFlowContext } = useContext(
        WaitingListFlowContext
    );
    const [paymentOption, setPaymentOption] = useState(null);

    const [paymentOptions] = useProductAvailability(
        false,
        waitingListFlowContext.product,
        new Date(),
        waitingListFlowContext
    );

    let urlParams = useMemo(
        () => new URLSearchParams(window.location.search),
        [window.location.search] // Recreate only when URL search changes
    );

    useEffect(() => {
        const loggedIn = waitingListFlowContext.episerver.loggedIn;
        const switchAccountUrl =
            waitingListFlowContext.episerver.switchAccountUrl;
        const activeProfile = !!waitingListFlowContext.episerver.activeProfile;
        const hasMoreThanOneProfile =
            waitingListFlowContext.episerver.hasMoreThanOneProfile;
        const alreadyLoggedIn = !!waitingListFlowContext.user;
        const productNotSelected = !waitingListFlowContext.productConfirmed;
        const urlParams = new URLSearchParams(window.location.search);
        const loginType = urlParams.get("L") ?? urlParams.get("l");
        history.replaceState({ activeStep: 1 }, document.title);

        if (
            alreadyLoggedIn ||
            productNotSelected ||
            ((!loggedIn || !loginType) && !hasMoreThanOneProfile)
        ) {
            return;
        }

        if (
            loginType === "lgn" &&
            loggedIn &&
            hasMoreThanOneProfile &&
            !activeProfile
        ) {
            window.location.href =
                switchAccountUrl + encodeURIComponent("?" + urlParams);
            return;
        }

        if (
            waitingListFlowContext.episerver.hasWebticketAccount &&
            !shouldAccountBeUpdated(waitingListFlowContext) &&
            (!hasMoreThanOneProfile || activeProfile)
        ) {
            setWaitingListFlowContext({
                ...waitingListFlowContext,
                activeStep: waitingListFlowContext.vehicle.index,
                user: {
                    email: waitingListFlowContext.episerver.emailAddress,
                    givenName: waitingListFlowContext.episerver.given_name,
                    familyName: waitingListFlowContext.episerver.family_name,
                },
            });
        } else if (loginType === "gst") {
            setWaitingListFlowContext({
                ...waitingListFlowContext,
                activeStep: waitingListFlowContext.createAccount.index,
                guest: true,
            });
        } else if (loginType === "lgn") {
            setWaitingListFlowContext({
                ...waitingListFlowContext,
                activeStep: waitingListFlowContext.createAccount.index,
                guest: false,
            });
        }
    }, [waitingListFlowContext.episerver.activeProfile]);

    const handleJoinWaitingList = () => {
        const loggedIn = waitingListFlowContext.episerver.loggedIn;
        const switchAccountUrl =
            waitingListFlowContext.episerver.switchAccountUrl;
        const activeProfile = !!waitingListFlowContext.episerver.activeProfile;
        const hasMoreThanOneProfile =
            waitingListFlowContext.episerver.hasMoreThanOneProfile;

        let activeStep = null;
        let user = null;

        urlParams =
            urlParams.toString().length > 0
                ? "?" + urlParams.toString() + "&"
                : "?";

        if (
            waitingListFlowContext.episerver.loggedIn &&
            (!hasMoreThanOneProfile || activeProfile)
        ) {
            user = {
                email: waitingListFlowContext.episerver.emailAddress,
                givenName: waitingListFlowContext.episerver.given_name,
                familyName: waitingListFlowContext.episerver.family_name,
            };
            if (
                waitingListFlowContext.episerver.hasWebticketAccount &&
                !shouldAccountBeUpdated(waitingListFlowContext)
            ) {
                activeStep = waitingListFlowContext.vehicle.index;
            } else {
                activeStep = waitingListFlowContext.createAccount.index;
            }
        } else if (loggedIn && hasMoreThanOneProfile && !activeProfile) {
            activeStep = waitingListFlowContext.paymentTerm.index;
            window.location.href =
                switchAccountUrl + encodeURIComponent(urlParams + "l=lgn");
        } else {
            activeStep = waitingListFlowContext.paymentTerm.index;
            window.location.href =
                waitingListFlowContext.episerver.loginUrl +
                encodeURIComponent(urlParams + "l=lgn");
        }

        setWaitingListFlowContext({
            ...waitingListFlowContext,
            user,
            activeStep,
            paymentTerm: {
                ...waitingListFlowContext.paymentTerm,
                paymentOption,
            },
            productConfirmed: true
        });
    };

    const formLang = {
        ...waitingListFlowContext.localization.global,
        ...waitingListFlowContext.localization.onlineBooking,
        ...waitingListFlowContext.localization.login,
        buttons: {
            ...waitingListFlowContext.localization.global.buttons,
            ...waitingListFlowContext.localization.onlineBooking.buttons,
            ...waitingListFlowContext.localization.login.buttons,
        },
        language: waitingListFlowContext.localization.language,
    };

    return (
        <div className="waitinglistflowpage__app">
            <BackNavigation />
            <div className="single-step">
                <h2>{formLang.joinwaitinglist}</h2>

                <WaitingListPreview formLang={formLang} />

                <div className="waitinglistflowpage__instruction__info">
                    <label className="left">
                        {formLang.instructions.queueposition.label}:
                    </label>
                    <span className="right">
                        {" "}
                        {formLang.instructions.queueposition.description.replace(
                            "[~X]",
                            `~${
                                parseInt(
                                    waitingListFlowContext.waitingList
                                        .nextAvailablePosition || 1
                                ) - 1
                            }`
                        )}
                    </span>
                </div>

                {paymentOptions.length > 0 && (
                    <Fragment>
                        <div className="waitinglistflowpage__paymentterm">
                            <RadioButtonListWithLabel
                                text={formLang.paymentSelection}
                                subText={formLang.paymentSelectionSubtext}
                                options={paymentOptions}
                                priceTimes={1}
                                locale={waitingListFlowContext.country}
                                value={paymentOption}
                                setValue={setPaymentOption}
                                disabled={false}
                            />
                        </div>
                    </Fragment>
                )}

                {!waitingListFlowContext.episerver.loggedIn && (
                    <h2 className="smallmargin">{formLang.heading}</h2>
                )}
                {!waitingListFlowContext.episerver.loggedIn &&
                    formLang.loginPreamble && (
                        <p className="maxwidth margin center">
                            {formLang.loginPreamble}
                        </p>
                    )}
                {waitingListFlowContext.episerver.loggedIn ? (
                    <></>
                ) : (
                    <p className="italic center">{formLang.loginnote}</p>
                )}
                <button
                    className="single-step__button single-step__button--next"
                    data-booking-flow-step="ltp-selectproduct"
                    onClick={handleJoinWaitingList}
                >
                    {waitingListFlowContext.episerver.loggedIn
                        ? formLang.buttons.nextStep
                        : formLang.buttons.loginOrCreate}
                </button>
            </div>
        </div>
    );
};

export default React.memo(WaitingListProductDisplay);
